/**
    * Build the options for the select field
    * @param {*} options 
    * @returns 
    */
export const buildOptionsForSelect = (options) => {
    if (!options || !Array.isArray(options)) return null;

    return options
        .filter(option => option !== "")
        .map(option => {
            return {
                value: option,
                label: option
            };
        });
}